import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { remarkArray } from "../../constants/remarkArray";
import { updateRemark } from "../../actions/Saved.action";
import { connect } from "react-redux";

const RemarkSelector = ({
  remark,
  setRemark,
  data,
  updateRemark,
  studentId,
  year,
}) => {
  return (
    <div className="card card-body shadow my-4 py-4 d-flex">
      <Row>
        <Col md={4}>
          <h4 className="">Remark Control </h4>
        </Col>
        <Col md={6}>
          <Form.Select
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
          >
            {remarkArray.map((rem, i) => (
              <option value={rem.name} key={i}>
                {rem.text}
              </option>
            ))}
          </Form.Select>
        </Col>
        <Col md={2}>
          <Button
            onClick={() => {
              if (data && data.id && data.term && year) {
                updateRemark(
                  data.id,
                  data.term,
                  studentId,
                  remark === null ? "A" : remark,
                  year
                );
              }
            }}
          >
            Save
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default connect(null, { updateRemark })(RemarkSelector);
